import React, { useState, useEffect } from 'react'
import Search from '../components/Search';
import { MdSearch, MdCalendarMonth } from 'react-icons/md';
import Table from '../components/Table';
import '../styles/userdirectory.css';
import '../styles/login.css'
import axios from 'axios';
import { Modal, Button, Pagination } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import CustomButton from '../components/Button';
import { AiFillEye, AiFillEyeInvisible, AiOutlineMenu } from "react-icons/ai";
import { RxCross1, RxCross2 } from 'react-icons/rx'
import config from '../config';
import moment from 'moment';
import Alert from '../components/Alert';
import Loading from '../components/Loadingbutton';
import Sidebar from '../components/Sidebar';
import Paginationlist from './Paginationlist';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // Import the styles
import 'react-date-range/dist/theme/default.css'; // Import the theme

const mainUrl = config.baseurl;

const UserDirectory = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [togglesidebar, setTogglesidebar] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [showDeletModal, setShowDeletModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [editUserData, setEditUserData] = useState({ fullName: '', phoneNumber: '', info: '', isBanned: false, isSuspended: false, isReported: false, expires: '' });
  const [userData, setUserData] = useState({});
  const [activeUser, setActiveUser] = useState('AllUsers');
  const [showAlert, setShowAlert] = useState({ title: '', message: '', type: '', isShow: false });
  const [error, setError] = useState({ errorFor: '', message: '' });
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [apiCall, setApiCall] = useState({ type: 'post', slug: 'getCurrentUsers', body: { users: activeUser, recordPerPage, pageNumber } });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [totalUser, setTotalUser] = useState(0);
  const [placeHolder, setPlaceHolder] = useState('From-To');
  const [clearFilter, setClearFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  const token = localStorage.getItem('token')

  const handleRecordPerPage = (event) => {
    setPageNumber(1);
    console.log('recordPerPage', event.target.value);
    setRecordPerPage(event.target.value);
  }

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      let payload = {
        users: activeUser, 
        recordPerPage, 
        pageNumber,
        search: searchText,
        dateFrom,
        dateTo,
      };
      console.log('payload ', payload);
      
      try {
        const response = await axios({
          method: apiCall.type,
          url: `${mainUrl}/api/${apiCall.slug}`,
          data: payload,
          headers: {
            "content-type": "application/json",
            "authorization": `${token}`
          },
        });
        const data = response.data;
        setTotalUser(data.totalUsers);
        setApiData(data.data);
        console.log('API body ', payload);
        console.log('GEtusers Api data ', data.data);
        
        setIsLoading(false);
      }
      catch (error) {
        setIsLoading(false);
        setShowAlert({ title: "Alert", message: `Internal Server Error`, type: 'danger', isShow: true });
        console.log('apiError ' + error);
      }
    }
    fetchData();
  }, [apiCall, pageNumber, recordPerPage]);

  const activeUserClass = (id) => {
    let active = document.getElementById(id);
    const elements = document.getElementsByClassName('users');
    for (let index = 0; index < elements.length; index++) {
      const element = elements[index];
      element.classList.remove('selected_users');
      active.classList.add("selected_users");
    }
  }

  const handleAllUsers = () => {
    activeUserClass("all");
    setActiveUser('AllUsers');
    setPageNumber(1);
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: 'AllUsers', recordPerPage, pageNumber } });
  }

  const handleBannedUsers = () => {
    activeUserClass("banned");
    setActiveUser('BannedUsers');
    setPageNumber(1);
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: 'BannedUsers', recordPerPage, pageNumber } });
  }

  const handleSuspendedUsers = () => {
    activeUserClass("suspended");
    setActiveUser('SuspendedUsers');
    setPageNumber(1);
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: 'SuspendedUsers', recordPerPage, pageNumber } });
  }

  const handleDeletedUsers = () => {
    activeUserClass("deleted");
    setActiveUser('DeletedUsers');
    setPageNumber(1);
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: 'DeletedUsers', recordPerPage, pageNumber } });
  }

  const handleReportedUsers = () => {
    activeUserClass("reported");
    setActiveUser('ReportedUsers');
    setPageNumber(1);
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: 'ReportedUsers', recordPerPage, pageNumber } });
  }

  const onKeyDown = (e) => {
    setSearchText(e.target.value);
    e.key === 'Enter' && onSearchClick();
  }


  const onSearchClick = (event) => {
    let stxt = document.getElementById('search_text').value
    console.log('Searched text ', searchText);
    setApiCall({ type: 'post', slug: 'filterUserBySearch', body: { search: stxt, users: activeUser } });
  }

  const toggleDeletModal = () => {
    return setShowDeletModal(!showDeletModal);
  }

  const openDeletModal = async (id) => {
    toggleDeletModal();
    setDeleteUserId(id);
  }

  const deleteUser = async () => {
    try {
      const response = await axios({
        method: 'post',
        url: `${mainUrl}/api/postDeleteUser`,
        data: {
          userId: deleteUserId,
        },
        headers: {
          "content-type": "application/json",
          "authorization": `${token}`
        }
      });
      const data = response.data;
      setDeleteUserId("");
      toggleDeletModal();
      setShowAlert({ title: "Alert", message: `${data.data.fullName} is deleted successfully.`, type: 'success', isShow: true });
    }
    catch (error) {
      setIsLoading(false);
      setShowAlert({ title: "Alert", message: 'Internal Server Error', type: 'danger', isShow: true });
      console.log('apiErrror ' + error);
    }
  }

  const toggleEditModal = () => {
    return setShowEditModal(!showEditModal);
  }

  const openEditModal = async (user) => {
    toggleEditModal();
    setUserData(user);
    setEditUserData({
      fullName: user.fullName,
      phoneNumber: user.phoneNumber,
      info: user.info,
      isBanned: user.isBanned,
      isSuspended: user.suspendMeta && user.suspendMeta.isSuspended,
      expires: user.suspendMeta && user.suspendMeta.expires,
      isReported: user.isReported,
    });
    // console.log(editUserData);
  }

  const editUser = async () => {
    // console.log(editUserData);
    const body = {
      userId: userData.id,
      fullName: editUserData.fullName,
      phoneNumber: editUserData.phoneNumber,
      info: editUserData.info,
      isBanned: editUserData.isBanned,
      isReported: editUserData.isReported,
      isSuspended: editUserData.isSuspended,
      expires: editUserData.expires,
    }
    try {
      const response = await axios({
        method: 'post',
        url: `${mainUrl}/api/editUser`,
        data: body,
        headers: {
          "content-type": "application/json",
          "authorization": `${token}`
        }
      });
      const data = response.data;
      setApiCall({ ...apiCall });
      setShowAlert({ title: "Alert", message: `${data.data.fullName} edited successfully.`, type: 'success', isShow: true });
      toggleEditModal();

    }
    catch (error) {
      setIsLoading(false);
      setShowAlert({ title: "Alert", message: "User not edited.", type: 'danger', isShow: true });
    }
  }

  const handleEditInputChange = (e) => {
    let length = e.target.value.length;
    let element = document.getElementsByName(e.target.name)[0];
    if (length === 0) {
      element.style.boxShadow = '1px 1px 3px red, -1px -1px 3px red';
      setError({ errorFor: e.target.name, message: 'This field is required!' });
      setEditUserData({ ...editUserData, [e.target.name]: e.target.value });
      console.log('length ' + length);
    }
    if (length > 0) {
      element.style = 'none';
      setError({ errorFor: '', message: '' });
      setEditUserData({ ...editUserData, [e.target.name]: e.target.value });
      console.log('length > ' + length);

    }
  }

  const handleIsBanned = () => {
    setEditUserData({ ...editUserData, isBanned: !editUserData.isBanned });
  }

  const handleIsSuspended = () => {
    setEditUserData({ ...editUserData, isSuspended: !editUserData.isSuspended });
  }

  const handleIsReported = () => {
    setEditUserData({ ...editUserData, isReported: !editUserData.isReported });
  }

  const handleExpires = () => {
    let date = document.getElementsByName('expires')[0];
    setEditUserData({ ...editUserData, expires: date.value })
  }


  const handleAlert = () => {
    setShowAlert({ title: '', message: '', type: '', isShow: false })
  }

  const handlesidebar = () => {
    if (togglesidebar) setTogglesidebar(false);
    else setTogglesidebar(true)
  }

  const handlecallback = (page) => {
    console.log('Page number ', page);
    setPageNumber(page);
  }

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  }

  const handleRangeChange = (ranges) => {
    let start =  new Date(ranges.selection.startDate);
    let end =  new Date(ranges.selection.endDate);
    setSelectedRange([ranges.selection]);
    setPlaceHolder(`${start.getFullYear()}-${start.getMonth()+1}-${start.getDate()}~${end.getFullYear()}-${end.getMonth()+1}-${end.getDate()}`);
    setSelectedRange([ranges.selection]);
    setDateFrom(`${ranges.selection.startDate}`);
    setDateTo(`${ranges.selection.endDate}`);
    setApiCall({ type: 'post', slug: 'filterUsersByDate', body: { activeUser, dateFrom: ranges.selection.startDate, dateTo: ranges.selection.endDate, recordPerPage, pageNumber } });
    setClearFilter(true);
  };

  const setInitialState = async (event) => {
    toggleDatePicker();
    setApiCall({ type: 'post', slug: 'getCurrentUsers', body: { users: activeUser, recordPerPage, pageNumber } });
    setClearFilter(false);
    setPlaceHolder('From-to');
  }

  return (
    <div className='main-container'>
      <Sidebar togglevalue={togglesidebar} />

      <main>
        <div className="container-fluit">
          <div onClick={handlesidebar}>
            {togglesidebar ? <div className='toggleicon'><AiOutlineMenu size={30} /> </div> : <div className='crossicon'><RxCross1 size={30} /></div>}
          </div>
          {showAlert.isShow && <Alert title={showAlert.title} message={showAlert.message} type={showAlert.type} isShow={showAlert.isShow} handleAlert={handleAlert} />}

          <div id='admin_btn'>
            <h2 id="userdirectory_heading">User Directory</h2>
          </div>

          <div className="container-users">
            <div className='container-serach'>
              <Search icon={<MdSearch />} id="search_text" type='text' iconId="search_text_icon" onKeyDown={onKeyDown} onSearchClick={onSearchClick} />
              
              <div className='date_filter' id='reported_datapicker'>
                <Search icon={<MdCalendarMonth />} id="date_picker" type='text' iconId="search_date_icon" toggleDatePicker={toggleDatePicker} placeholder={placeHolder} clearFilter={clearFilter} setInitialState={setInitialState} />

                  {showDatePicker && <DateRangePicker
                    ranges={selectedRange}
                    onChange={handleRangeChange}
                    startDatePlaceholder="From"
                    endDatePlaceholder='To'
                    className='date-range-picker'
                    scroll={{ enabled: false }}
                    footerContent={true}
                    editableDateInputs={false}
                    months={1}
                  />}
              </div>
              
            </div>
            <div className='dropdown'> ReportPerPage
              <select name="" id="" onChange={handleRecordPerPage} className='custom-select'>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className="filter_section">
              <button className='user_status users selected_users' id="all" onClick={handleAllUsers}>All</button>
              <button className='user_status users' id="banned" onClick={handleBannedUsers}>Banned</button>
              <button className='user_status users' id="suspended" onClick={handleSuspendedUsers}>Suspended</button>
              <button className='user_status users' id="deleted" onClick={handleDeletedUsers}>Deleted</button>
              <button className='user_status users' id="reported" onClick={handleReportedUsers}>Reported</button>
            </div>
            {isLoading
              ? <Loading />
              : apiData && apiData.length > 0
                ? <Table data={apiData} openDeletModal={openDeletModal} openEditModal={openEditModal} />
                : <img className="no_data_found" src='/assets/images/no-data-found.jpg' alt='Not Data found' />}
          </div>
        
          <Paginationlist recordPerPage={recordPerPage} totalUser={totalUser} handlecallback={handlecallback} pageNumber={pageNumber} /> 

          <Modal show={showDeletModal}>
            <Modal.Header onClick={toggleDeletModal} >
              <Modal.Title>Delete User</Modal.Title>
              <RxCross2 size={25} />
            </Modal.Header>
            <Modal.Body>
              Are you want to sure to delete this user?
            </Modal.Body>
            <Modal.Footer>
              {/* <Button variant="secondary" onClick={toggleDeletModal}>
                Close
              </Button>
              <Button variant="success" onClick={deleteUser}>
                Delete
              </Button> */}
              <button onClick={toggleDeletModal} className="modal_btn" id="close_btn" style={{ marginRight: '1rem' }} > Close </button>
              <button onClick={deleteUser} className="modal_btn" id="delete_btn" type="submit">Delete</button>
            </Modal.Footer>
          </Modal>


          <Modal show={showEditModal}>
            <Modal.Header onClick={toggleEditModal} >
              <Modal.Title>Edit User</Modal.Title>
              <RxCross2 size={25} />
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3" controlId="fullname">
                  <Form.Label>Name: </Form.Label>
                  <Form.Control type="text" placeholder="Enter full name" name="fullName" onChange={handleEditInputChange} value={editUserData.fullName} />
                  {error.errorFor === "fullName" && <p style={{ color: 'red' }} > {error.message} </p>}
                </Form.Group>

                <Form.Group className="mb-3" controlId="phonenumber">
                  <Form.Label>Phone Number: </Form.Label>
                  <Form.Control type='phone' placeholder="1234567890" pattern='[0-9]{10}' name="phoneNumber" value={editUserData.phoneNumber} onChange={handleEditInputChange} />
                  {error.errorFor === "phoneNumber" && <p style={{ color: 'red' }} > {error.message} </p>}
                </Form.Group>

                <Form.Group className="mb-3" controlId="Reported">
                  <Form.Check type='checkbox' label="Reported" name='isReported' defaultChecked={editUserData.isReported} onClick={handleIsReported} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="Banned">
                  <Form.Check type="checkbox" label="Ban User" name='isBanned' defaultChecked={editUserData.isBanned} onClick={handleIsBanned} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="suspened">
                  <Form.Check type="checkbox" label="Suspend User" name='isSuspended' defaultChecked={editUserData.isSuspended} onClick={handleIsSuspended} />
                </Form.Group>

                {editUserData.isSuspended &&
                  <Form.Group className="mb-3" controlId="suspened">
                    <Form.Label>Suspention Date: </Form.Label>
                    <Form.Control type="datetime-local" placeholder='Choose a date' onChange={handleExpires} name='expires' value={editUserData.expires ? editUserData.expires : moment().format('yyyy-MM-DDThh:mm')} min={moment().format('yyyy-MM-DD')} />
                  </Form.Group>
                }

                <Form.Group className="mb-3" controlId="info">
                  <Form.Label>About</Form.Label>
                  <Form.Control type="text" placeholder="Hey there, i am using Rao Chat!" name="info" value={editUserData.info} onChange={handleEditInputChange} />
                  {error.errorFor === "info" && <p style={{ color: 'red' }} > {error.message} </p>}
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button onClick={toggleEditModal} className="adminmodal_btn" id="close_btn" style={{ marginRight: '1rem' }} > Close </button>
              <button onClick={editUser} className="adminmodal_btn" id="send_btn" type="submit">update user</button>
            </Modal.Footer>
          </Modal>

        </div>
      </main>
    </div>
  )
}

export default UserDirectory;